import { z } from 'zod';
export const timestampSchema = z.union([
    z.date(),
    z.string().datetime(),
    z.string().transform((str) => new Date(str))
]).optional();
export const timestampRequiredSchema = z.union([
    z.date(),
    z.string().datetime(),
    z.string().transform((str) => new Date(str))
]);
export const numericSchema = z.union([z.number(), z.string().regex(/^\d+$/).transform(val => parseInt(val, 10))]);
export const paginationSchema = z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
    totalPages: z.number(),
    hasNext: z.boolean(),
    hasPrev: z.boolean(),
    offset: z.number()
});
//# sourceMappingURL=commonSchemas.js.map